import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_CONSOLE_LOGS,
  GET_AZURE_CONSOLE_LOGS_SUCCESS,
  GET_AZURE_CONSOLE_LOGS_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureConsoleLogsList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureConsoleLogsStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_CONSOLE_LOGS:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_CONSOLE_LOGS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureConsoleLogsList: action.data,
        error: null,
      };
    case GET_AZURE_CONSOLE_LOGS_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
